import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewChild,
    HostListener,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { TableLightComponent } from "../table-light.component";
import { TableLightButtonOption } from "../models/table-light-button-option";

@Component({
    standalone: false,
    selector: "app-table-light-column",
    templateUrl: "./table-light-column.component.html",
    styleUrls: ["./table-light-column.component.css"],
})
export class TableLightColumnComponent {
    @Input() editable: boolean = false;
    @Input() header: string;
    @Input() numberPipe: string = "1.0";
    @Input() options: TableLightButtonOption[];
    @Input() type: ColumnTypes;
    @Input() value: string;
    @Input() visible: boolean = true;
    @Input() width: number;
    @Input() totalInFooter: boolean = false;
    @Input() styleClass?: string = "";
    @Input() frozen?: boolean = false;
    @Input() unfrozenOnMobile?: boolean = false;
    @Input() leftBuffer?: string = null;

    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRowChanged: EventEmitter<any> = new EventEmitter<any>();

    change: (event) => void;

    private sanitizer: DomSanitizer;

    @ViewChild("numberInput", { read: TemplateRef })
    private numberInputTemplate: TemplateRef<any>;

    @ViewChild("textInput", { read: TemplateRef })
    private textInput: TemplateRef<any>;

    @ViewChild("optionButtons", { read: TemplateRef })
    private optionButtonsTemplate: TemplateRef<any>;

    @ViewChild("hyperlink", { read: TemplateRef })
    private hyperlinkTemplate: TemplateRef<any>;

    @ViewChild("dateInput", { read: TemplateRef })
    private dateInputTemplate: TemplateRef<any>;

    template: TemplateRef<any>;

    constructor(table: TableLightComponent, sanitizer: DomSanitizer) {
        this.sanitizer = sanitizer;

        table.addColumn(this);
    }

    ngAfterViewInit() {
        switch (this.type) {
            case ColumnTypes.Number:
            case ColumnTypes.Currency:
                this.template = this.numberInputTemplate;
                this.width = this.width || 100;
                this.styleClass += " text-end";
                break;
            case ColumnTypes.Options:
                this.template = this.optionButtonsTemplate;
                this.width = this.width || 50;
                break;
            case ColumnTypes.Hyperlink:
                this.template = this.hyperlinkTemplate;
                break;
            case ColumnTypes.Date:
                this.template = this.dateInputTemplate;
                break;
            default:
                this.template = this.textInput;
                break;
        }

        if (this.frozen) this.styleClass += " sticky-column";

        if (this.editable) this.styleClass += " editable-cell";
        else this.styleClass += " view-cell";

        this.width = this.width || 200;
    }

    @HostListener("window:resize")
    onResize() {
        let isMobileSize = window.innerWidth <= 768;
        let makeSticky = true;

        if (!this.frozen || (isMobileSize && this.unfrozenOnMobile == true))
            makeSticky = false;

        var styles = this.styleClass.split(" ");

        for (var i = styles.length - 1; i >= 0; i--)
            if (styles[i] == "sticky-column") styles.splice(i, 1);

        if (makeSticky == true) styles.push("sticky-column");

        this.styleClass = styles.join(" ");
    }

    isEditable(row: object): boolean {
        if (row["disabled"] == true) return false;
        else if ((row["disabledCells"] || []).some((p) => p == this.value))
            return false;

        return this.editable;
    }

    onEnterPressed($event) {
        $event.preventDefault();
        $event.stopPropagation();

        return false;
    }

    onModelChanged(event: any, row: object, rowIndex: number) {
        let eventModel = {
            event: event,
            row: row,
            column: this.value,
            rowIndex: rowIndex,
        };

        if (this.onChange.observers.length > 0) this.onChange.emit(eventModel);
        if (this.onRowChanged.observers.length > 0)
            this.onRowChanged.emit(eventModel);
    }

    isButtonVisible(
        option: TableLightButtonOption,
        row: object,
        rowIndex: number,
        rowCount: number
    ): boolean {
        var value = true;

        if (option.hide) value = !option.hide(row, rowIndex, rowCount);

        return value;
    }

    onButtonOptionClicked(
        event: any,
        row: object,
        option: TableLightButtonOption,
        rowIndex: number
    ) {
        if (option.click) option.click(event, row, this, rowIndex);
    }

    hasVisibleButtonOptions(
        row: object,
        rowIndex: number,
        rowCount: number
    ): boolean {
        var options = this.options || [];

        return (
            options.filter((x) => {
                if (!x.hide) return true;
                return x.hide(row, rowIndex, rowCount) != true;
            }).length > 0
        );
    }

    getColumnHref(item, column): SafeUrl {
        var url = item.url || item[column.value] || "#";
        var urlReplaced = url
            .replace("%", "%25")
            .replace("&", "%26")
            .replace("+", "%2B")
            .replace("#", "%23");
        return this.sanitizer.bypassSecurityTrustUrl(urlReplaced);
    }

    getLinkName(item: any, url: string): string {
        if (item)
            if (
                item.originalFileName ||
                (item.fileName && item.fileName.indexOf("/") > -1)
            )
                return item.originalFileName || item.fileName;
            else if (url.lastIndexOf("/") > -1)
                return url.substr(url.lastIndexOf("/") + 1);

        return "Download";
    }
}

enum ColumnTypes {
    Text = "text",
    Number = "number",
    Options = "options",
    Hyperlink = "hyperlink",
    Currency = "Currency",
    Date = "Date",
}
